import { useTranslation } from 'react-i18next'

const ForeignDadStart = (props) => {
  const { t } = useTranslation()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="foreigndad-start-title"
      {...props}
    >
      <title id="foreigndad-start-title">{t('antagonists:foreigndad:components:start')}</title>
      <defs>
        <clipPath id="foreigndad-b">
          <path
            d="M1495.47 290.13s4.95-4.37 14.75 8.69c9.8 13.07 22.82 36.7 22.82 36.7s16.16-20.61 22.69-29.76c6.53-9.15 10.31-22.83 10.31-22.83s19.75 9.58 30.53 13.83c10.78 4.25 24.33 6.19 31.8 16.21 3.41 4.58-15.87 50.29-16.85 64.34-.98 14.05 7.97 76.23 7.95 90.61-.02 14.6 12.2 20.86 4.49 30.01-11.11 13.19-1.62 61.7-1.62 61.7s-50.72 8.09-86.98 10.7c-36.27 2.61-71.92-4.97-71.92-4.97s8.19-33.68 6.59-54.52c-1.59-20.67-7.82-27.78-8.48-39.21-.65-11.44 5.3-55.64.53-84.78-3.13-19.1-30.19-68.09-20.22-77.08 5.34-4.82 14.93-9.4 24.98-11.28 12.9-2.42 28.61-8.37 28.61-8.37Z"
            style={{
              fill: '#f1f1f3',
            }}
          />
        </clipPath>
        <clipPath id="foreigndad-c">
          <path
            d="M1504.13 189.11c-5.59 3.86-.19 18.52-.19 18.52s-3.67.96-4.44 6.75c-.77 5.79-.39 37.23 1.74 41.67 2.12 4.44 14.85 21.61 20.26 25.66s16.98 3.28 22.96-1.16c5.98-4.44 21.22-21.03 21.8-26.62s1.35-26.82 1.35-30.29-2.51-7.14-4.44-9.65c-1.93-2.51-3.47-5.02-3.47-5.02s8.49-12.35 2.7-17.94c-2.59-2.5-16.59 3.67-27.97 3.28-11.38-.39-25.33-8.63-30.29-5.21Z"
            style={{
              fill: '#9d8042',
            }}
          />
        </clipPath>
        <style>
          {
            '.d{fill:#004a7c}.e{fill:#00101f}.f{fill:#f1f1f3}.g{fill:#e2ebf4}.h{fill:#9d8042}.i{fill:#c9936d}.j{fill:#11242f}.k{fill:#404b51}.l{fill:#272a3e}.m{fill:#2f2b39}.n{fill:#4f4e47}.o{clip-path:url(#foreigndad-c)}.p{clip-path:url(#foreigndad-b)}'
          }
        </style>
      </defs>
      <path
        d="M1591.63 304.2c-22.53 8.38 7.87 71.66 16.58 94.64 9.55 25.22-.35 53.33 6.93 60.44 7.28 7.11 45.72 23.7 51.14 9.9 5.42-13.8.64-60.98-7.72-88.45-7.97-26.19-22.4-57.31-26.9-65.56s-31.77-14.04-40.03-10.97Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <path
        d="M1457.06 521.54s6.14 12.15 9.95 13.9c3.8 1.76 13.22 10.1 18.14 14.39 4.91 4.29 23.92 14.56 23.92 14.56s-.59 6.15-7.54 4.48c-6.95-1.68-12.84-5.68-12.84-5.68s-2.07 9.2-12.62 12.53c-10.55 3.33-20.1 4.75-20.1 4.75s-7.22-17.49-9.4-24.9c-2.57-8.74-7.11-15.52-7.11-15.52l17.6-18.51Z"
        style={{
          fill: '#9d8042',
        }}
      />
      <path
        d="M1468.97 298.18s-2.5 82.31-14.05 104c-12.67 23.8-19.93 48.11-28.05 54.24-8.12 6.13-36.55 5.15-40.18-9.22-3.63-14.37 7.41-43.21 19.19-69.4 11.23-24.97 21.25-55.5 26.25-63.45 7.04-11.19 36.84-16.17 36.84-16.17Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <path
        d="M1431.26 431.91s9.87 45.28 16.27 62.64 16.04 36.61 16.04 36.61-3.65 2.95-11.74 8.87c-8.09 5.91-11.56 11.66-11.56 11.66l-10.17-15.01s-11.7-4.96-17.57-20.85c-5.87-15.89-18.05-43.85-21.33-50.8-3.83-8.15-9.32-21.68-4.07-29.95 5.24-8.27 39.78-19.29 44.13-3.16Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <path
        d="M1503.65 248.83s1.16 25.87-2.08 37.42c-3.23 11.55-10.16 30.49-10.16 30.49s38.58 53.6 38.81 52.9c.23-.69 43.89-62.84 43.43-63.53-.46-.69-8.55-12.71-10.16-24.95-1.62-12.24-2.08-26.11-2.08-26.11l-57.75-6.24Z"
        style={{
          fill: '#9d8042',
        }}
      />
      <path
        d="M1495.47 290.13s4.95-4.37 14.75 8.69c9.8 13.07 22.82 36.7 22.82 36.7s16.16-20.61 22.69-29.76c6.53-9.15 10.31-22.83 10.31-22.83s19.75 9.58 30.53 13.83c10.78 4.25 24.33 6.19 31.8 16.21 3.41 4.58-15.87 50.29-16.85 64.34-.98 14.05 7.97 76.23 7.95 90.61-.02 14.6 12.2 20.86 4.49 30.01-11.11 13.19-1.62 61.7-1.62 61.7s-50.72 8.09-86.98 10.7c-36.27 2.61-71.92-4.97-71.92-4.97s8.19-33.68 6.59-54.52c-1.59-20.67-7.82-27.78-8.48-39.21-.65-11.44 5.3-55.64.53-84.78-3.13-19.1-30.19-68.09-20.22-77.08 5.34-4.82 14.93-9.4 24.98-11.28 12.9-2.42 28.61-8.37 28.61-8.37Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <g
        style={{
          clipPath: 'url(#foreigndad-b)',
        }}
      >
        <path
          d="M1523.56 326.96s-.39 35.13 1.18 68.67c1.58 33.55 9.87 76.17 9.87 93.93 0 17.76-2.76 51.31-2.76 51.31l16.18.79s3.55-24.47 1.18-56.05c-2.37-31.57-9.45-72.35-10.24-88.93-.79-16.58-1.6-77.63-1.6-77.63l-13.81 7.89Z"
          style={{
            fill: '#e2ebf4',
          }}
        />
      </g>
      <path
        d="M1533.54 163.55c-10.8-.14-34.92 11.58-37.23 20.84-2.32 9.26-.77 37.43-.77 37.43l75.62-.19s4.44-20.45-.77-33.95c-5.21-13.5-21.99-23.92-36.85-24.12Z"
        style={{
          fill: '#404b51',
        }}
      />
      <path
        d="M1564.9 222.87s6.95-8.3 10.61-6.75c3.67 1.54.77 11.38-.58 15.82-1.35 4.44-3.67 13.5-6.75 13.31-3.09-.19-9.65-.19-9.65-.19l6.37-22.19ZM1501.42 219.79s-6.95-8.3-10.61-6.75c-3.67 1.54-.77 11.38.58 15.82 1.35 4.44 3.67 13.5 6.75 13.31 3.09-.19 9.65-.19 9.65-.19l-6.37-22.19Z"
        style={{
          fill: '#9d8042',
        }}
      />
      <path
        d="M1504.13 189.11c-5.59 3.86-.19 18.52-.19 18.52s-3.67.96-4.44 6.75c-.77 5.79-.39 37.23 1.74 41.67 2.12 4.44 14.85 21.61 20.26 25.66s16.98 3.28 22.96-1.16c5.98-4.44 21.22-21.03 21.8-26.62s1.35-26.82 1.35-30.29-2.51-7.14-4.44-9.65c-1.93-2.51-3.47-5.02-3.47-5.02s8.49-12.35 2.7-17.94c-2.59-2.5-16.59 3.67-27.97 3.28-11.38-.39-25.33-8.63-30.29-5.21Z"
        style={{
          fill: '#9d8042',
        }}
      />
      <g
        style={{
          clipPath: 'url(#foreigndad-c)',
        }}
      >
        <path
          d="M1522.34 251.78c-3.19 1.5-6.9 4.28-8.25 5.44-1.35 1.16-2.23 2.69-3.96 2.88-1.74.19-.77-4.05-3.28-9.45-1.2-2.58-2.99-22.45-5.34-30.4-1.09-3.68-5.04-6.27-5.04-6.27s-4.08 28.56-4.08 29.14 4.63 34.15 4.63 34.15l32.22 19.68 21.8-3.67s25.47-33.38 24.69-33.57-5.26-41.78-5.26-41.78-4.2.56-6.13 6.54c-1.93 5.98-4.79 34.7-10.31 36.31-2.04.59-5.44-6.56-9.75-8.62-4.18-2-8.72.37-11.81.56-3.09.19-8.48-1.71-10.12-.94Z"
          style={{
            fill: '#404b51',
          }}
        />
      </g>
      <path
        d="M1525.57 217.93s-12.73-2.89-15.82-3.47c-3.09-.58-6.95 4.05-6.95 4.05l1.16 2.51s3.09-2.12 7.52-.77c4.44 1.35 14.85 3.67 14.85 3.67l-.77-5.98ZM1536.66 218.8l1.24 5.07s14.34-5.52 16.18-5.04c1.84.48 5.07 1.11 5.07 1.11l.51-4s-3.01-2.82-7.39-3.27c-4.38-.44-15.61 6.12-15.61 6.12Z"
        style={{
          fill: '#272a3e',
        }}
      />
      <path
        d="M1530.09 268.4c6 .74 12.26-5.79 14.28-6.56 2.01-.77 3.11 0 3.66-1.35.55-1.35-3.11-4.05-8.79-5.02s-6.22 1.35-7.51 1.35-2.93-1.16-6.04-1.54c-3.11-.39-10.25 5.4-9.52 6.56.73 1.16 4.94 1.35 6.41 2.12s4.39 4.05 7.51 4.44Z"
        style={{
          fill: '#c9936d',
        }}
      />
      <path
        d="M1519.01 224.87c-1.73-.49-3.28.34-3.69 2.06-.41 1.72.5 2.72 2.03 3.25 1.8.63 3.16-.19 3.76-1.91.42-1.22-.32-2.9-2.1-3.4Z"
        style={{
          fill: '#2f2b39',
        }}
      />
      <path
        style={{
          fill: '#2f2b39',
        }}
        d="m1511.71 224.44 9.35 2.09 1.08-3.31-11.05-2.18.62 3.4zM1545.88 223.98c1.73-.49 3.28.34 3.69 2.06.41 1.72-.5 2.72-2.03 3.25-1.8.63-3.16-.19-3.76-1.91-.42-1.22.32-2.9 2.1-3.4Z"
      />
      <path
        style={{
          fill: '#2f2b39',
        }}
        d="m1553.11 223.61-9.42 2.23-1.07-3.31 10.53-2.39-.04 3.47z"
      />
      <path
        d="M1503.74 266.85s-.44 7.89.84 12.93c1.52 6.03 28.49 55.67 28.49 55.67s15.4-22.17 20.25-29.57c4.85-7.39 8.94-36.57 8.94-36.57l6.71 8.44s1.68 14.97 3.99 26.75c2.31 11.78 1.35 27.43 1.35 27.43l-19.34-18.94-23.29 28.42-19.1-28.56-24.48 17.23.33-38.54 11.52-20.99 3.79-3.69Z"
        style={{
          fill: '#e2ebf4',
        }}
      />
      <path
        d="M1508.8 924.93s4.74 12.33 1.95 18.09-11.42 21.38-11.42 21.38l41.51-1.37 3.62-15.08-5.85-27.14-29.81 4.11ZM1560.51 919.78s-.02 10.14-1.02 14.83c-1 4.69-3.47 17.09-3.47 17.09l23.79 25.99 23.71-21.16s-7.8-10.77-9.29-14.57c-1.49-3.8.57-21.4.57-21.4l-34.3-.78Z"
        style={{
          fill: '#004a7c',
        }}
      />
      <path
        d="M1556.98 937.84s-2.72 16.28-3.75 23.91c-1.04 7.63-.67 14.04-.67 14.04l20.02 8.01 4.14-3.8s3.57 2.16 5.12 8c1.55 5.84 3.06 9.61 9.99 12.54 6.93 2.94 27.82 10.03 32.59 9.72 9.13-.58 16.07-3.86 16.35-6.98.27-3.12.59-11.43-6.62-18.33-7.21-6.91-20.49-17.98-24.32-23.07s-7.57-21.02-19.25-18.83c-3.27.61-10.7 4.24-18.4 2.55-9.28-2.04-15.2-7.75-15.2-7.75ZM1507.82 945.74c.53 0 2.87-5.34 8.95-3.42 4.8 1.52 6.08 8.76 15.19 4.06 9.12-4.7 10.47-9.63 10.47-9.63s4.39 18.32 4.22 24.03c-.18 5.7.18 8.47.18 8.47s-8.61 7.61-9.14 7.43-4.74-.52-4.74-.52-1.41 2.94-1.41 9.34 2.11 8.47.7 11.06-18.27 16.25-35.84 14.18c-17.57-2.07-14.93-11.41-14.06-16.77.88-5.36 2.11-12.62 5.1-16.42 2.99-3.8 13.35-17.11 15.46-21.26 2.11-4.15 4.92-10.55 4.92-10.55Z"
        style={{
          fill: '#00101f',
        }}
      />
      <path
        d="M1468.23 513.88s37.12 6.95 60.38 7.04c23.26.08 92.08-8.91 92.08-8.91l-.48 24.68s16.89 52.79 17.96 69.97c1.07 17.18-5.25 118.44-9.22 132.76-3.97 14.32-10.25 64.16-12.47 79.84-2.22 15.69-13.94 107.54-13.94 107.54s-5.56 16.27-13.06 16.88c-7.49.6-32.39-9.6-32.39-9.6s-5.21-45.98-2.71-72.63 13.11-80.09 11.93-88.43c-1.17-8.34-4.22-69.31-9.69-93.26-5.47-23.95-13.83-50.57-20.92-77.4-7.1-26.83-67.49-88.47-67.49-88.47Z"
        style={{
          fill: '#11242f',
        }}
      />
      <path
        d="M1468.08 532.89s-12.8 28-19.05 40.64c-4.47 9.03 19.98 104.74 21.52 126.64 1.55 21.9 10.2 70.86 9.58 81.51-.62 10.64 8.35 82.42 12.06 101.88 3.71 19.46 13.91 56.57 13.91 56.57s7.11 2.74 14.53 3.35c7.42.61 24.11-8.21 24.11-8.21s4.02-27.37 1.55-55.35c-2.47-27.98-15.15-93.98-13.29-107.36 1.85-13.38 10.82-76.03 12.36-93.37 1.55-17.34 10.82-134.73 10.82-134.73l-66.77-24.63-20.71-6.69-.62 19.77Z"
        style={{
          fill: '#11242f',
        }}
      />
      <path
        d="M1583.52 515.93s.98 7.33 1.85 12.88c.87 5.55.87 12.6.87 12.6l6.29-.85s-.43-7.26-1.09-13.88c-.65-6.62-1.96-11.63-1.96-11.63l-5.96.88ZM1497.22 518.91s-.85 6.91-1.72 12.47c-.87 5.55-.87 12.6-.87 12.6l-6.29-.85s.43-7.26 1.09-13.88c.65-6.62 2.01-11.38 2.01-11.38l5.79 1.05Z"
        style={{
          fill: '#00101f',
        }}
      />
      <path
        d="M1542.61 528.27c2.31.15 3.53 2.04 3.5 3.3-.04 1.89-.47 3.87-3.86 3.93-2.46.04-3.76-1.6-3.76-3.98 0-1.68 1.74-3.41 4.13-3.26Z"
        style={{
          fill: '#4f4e47',
        }}
      />
      <path
        d="M1564.38 422.94s-11.02-13.73-16.55-17.13-18.79-7.69-23.48-12.19c-4.7-4.5-10.54-8.4-12.14-8.93-1.6-.53-23.07-15.08-23.07-15.08s2.45-6.05 7.05-3.81c4.61 2.24 18.39 10.1 19.34 10.61.95.51 1.8-.75.54-1.76s-11.05-7.16-13.43-8.74c-2.38-1.58-15.4-10.2-15.4-10.2s2.37-5.48 6.72-4.07c4.35 1.41 14.4 9.01 16.32 10.34s8.94 6.29 9.73 6.9 1.62.05.71-.56-9.94-7.48-11.41-8.45c-1.47-.97-20.54-12.21-20.54-12.21s1.33-5.62 6.72-4.18c5.39 1.44 16.73 8.51 18.65 9.84 1.92 1.33 9.28 6.42 9.96 6.79.68.37 1.98-.4.86-1.48s-9.37-7.35-11.06-8.56c-1.7-1.21-13.77-7.14-13.77-7.14s1.58-6.19 6.04-4.67c4.46 1.53 13.36 5.39 15.85 7.21 2.49 1.81 23.94 14.4 24.96 15.13 1.02.73.95-.89.19-2.31-.76-1.41-5.71-13.36-5.93-17.3-.22-3.94 4.8-5.63 4.8-5.63s3.04 6.22 4.98 10.68c1.94 4.46 8.74 12.65 9.11 15.43.37 2.79 2.02 20.41 3.56 22.66 1.55 2.25 25.34 17.68 25.34 17.68s-25.05 20.93-24.66 21.12Z"
        style={{
          fill: '#9d8042',
        }}
      />
      <path
        d="M1648.96 413.49s-29.26.39-45.6-8.29-37.98-21.6-37.98-21.6-6.59 4.93-13.52 12.15c-6.94 7.22-11.33 10.08-11.33 10.08l18.47 14.08s5.62 11.23 20.58 19.18c14.95 7.95 44.65 28.89 52.02 31.07 7.37 2.18 20.45 9.44 31.79 2.72 11.14-6.6.95-52.92-14.44-59.39Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
    </svg>
  )
}

export default ForeignDadStart
